<div class="muscle-beach-wrap">
    <!-- <h1 class="text-center">Welcome to the beach</h1> -->
    <div class="muscle-man-wrap">
        <div class="head"></div>
        <div class="body">
            <div class="left"></div>
            <div class="chest"></div>
            <div class="right"></div>
        </div>
        <div class="legs">
            <div class="left"></div>
            <div class="right"></div>
        </div>
    </div>
</div>